import { Hero } from './components/Hero';
import { FixedNavigation } from './components/FixedNavigation';
import { ResponsiveTable } from './components/ResponsiveTable';
import { Carousel } from './components/Carousel';
import { Movax } from './components/Movax';
import { MapApp } from './components/MapApp';
import { CoveringImage } from './components/CoveringImage';
import { QuantityMap } from './components/QuantityMap';
import { ImageGallery } from './components/ImageGallery';
import { footer } from './components/footer';
import { ReferencesApp } from './components/ReferencesApp';
import { DealersApp } from './components/DealersApp';
import { DLCenter } from './components/DLCenter';
import { MagnificPopup } from './components/MagnificPopup';
import { DownloadCenter } from './components/DownloadCenter';
import { ProductSearch } from './components/ProductSearch';
import { CustomSelect } from './components/CustomSelect';
import { CustomFileInput} from './components/CustomFileInput';
import { Questionnaire } from './components/Questionnaire';
import { Extranet } from './components/Extranet';
import { ExtranetNavigation } from './components/ExtranetNavigation';
import { ExtranetTable } from './components/ExtranetTable';
import { SidePanel } from './components/SidePanel';
import { MailChimpForm } from './components/MailChimpForm';
import { MaterialBank } from './components/MaterialBank';
import { MaterialBankApp } from './components/MaterialBankApp';
import { DownloadCenterv3 } from './components/DownloadCenterv3';
import { SelectionGrid } from './components/SelectionGrid';
import { Datepicker } from './components/datepicker';
import { MachineFiles } from './components/MachineFiles';
import { SparePartSearch } from './components/sparePartSearch';
import { SparePartBookSearch } from './components/sparePartBookSearch';
import { SparePartCart } from './components/SparePartCart';
import { FormWithConditionals } from './components/FormWithConditionals';
import { SparePartCartContact } from './components/sparePartContactForm';
import { SparePartOrderProcess } from './components/SparePartOrderProcess';
import { CommissioningReport } from './components/CommissioningReport';
import fetchFolderData from './components/FetchFolderData';
import master from './master.js';

declare function require(name:string);

// jquery does not currently support ES6 way of importing so we need to do it old school
var $ = require('jquery');

declare var global: any;
global.jQuery = $;

require('./vendor/bootstrap/umd/collapse');

var hero: Hero,
  mainNav = FixedNavigation,
  heroNewsCarousel: Carousel;

/* ---------------------------------------------------------------------- */
/*  Hero
/* ---------------------------------------------------------------------- */
hero = new Hero('hero');

/* ---------------------------------------------------------------------- */
/*  Responsive tables
/* ---------------------------------------------------------------------- */
$('table').each(function () {
  var table: ResponsiveTable = new ResponsiveTable(this, 'responsive-table__wrapper');
  table.init();
});

/* ---------------------------------------------------------------------- */
/*  Custom select
/* ---------------------------------------------------------------------- */
(function () {
  $('.js-custom-select').each(function () {
    var customSelect = new CustomSelect(this, 'custom-select');
    customSelect.init();
  });
})();

/* ---------------------------------------------------------------------- */
/*  Custom file upload
/* ---------------------------------------------------------------------- */
(function () {
  $('.custom-file').each(function () {
    var customFileInput = new CustomFileInput(this, 'custom-file');
    customFileInput.init();
  });
})();

/* ---------------------------------------------------------------------- */
/*  Featured news carousel
/* ---------------------------------------------------------------------- */
$('#js-news-carousel').each(function () {
  heroNewsCarousel = new Carousel('#js-news-carousel', {
    'accessibility': false,
    'adaptiveHeight': false,
    'autoplay': true,
    'autoplaySpeed': 3000,
    'arrows': false,
    'useCSS': true
  });

  heroNewsCarousel.start();
});

/* ---------------------------------------------------------------------- */
/*  References app
/* ---------------------------------------------------------------------- */
(function () {
  var $mapAppHolder = $('#js-map-app'),
    mapId, app;

  if ($mapAppHolder.length) {
    switch ($mapAppHolder.data('map-id')) {
      case 'references':
        ReferencesApp.init('#js-map-app', 'map-app');
        break;
      default:
        app = new MapApp('#js-map-app', 'map-app');
        app.init();
        break;
    }
  }
})();

/* ---------------------------------------------------------------------- */
/*  Dealers app
/* ---------------------------------------------------------------------- */
(function ()  {
  DealersApp.init('#js-dealer', 'dealer');
})();

/* ---------------------------------------------------------------------- */
/*  Quantity map
/* ---------------------------------------------------------------------- */
(function () {
  var id = 'js-quantity-map';
  $('#' + id).each(function () {
    var map = new QuantityMap(id);
  });
})();

/* ---------------------------------------------------------------------- */
/*  Covering images
/* ---------------------------------------------------------------------- */
$('.js-covering-image').each(function () {
  var coveringImage = new CoveringImage(this, 'covering-image', 100);
  coveringImage.init();
});

/* ---------------------------------------------------------------------- */
/*  Image gallery
/* ---------------------------------------------------------------------- */
$('.js-image-gallery').each(function () {
  var imageGallery = new ImageGallery(this, 'image-gallery');
  imageGallery.init();
});

/* ---------------------------------------------------------------------- */
/*  Lightbox image
/* ---------------------------------------------------------------------- */
$('.js-lightbox-image').each(function () {
  var imageGallery = new ImageGallery(this, 'lightbox-image');
  imageGallery.init();
});

/* ---------------------------------------------------------------------- */
/*  Footer
/* ---------------------------------------------------------------------- */
(function () {
  footer.init('js-footer');
})();

/* ---------------------------------------------------------------------- */
/*  Magnific popups
/* ---------------------------------------------------------------------- */
(function () {
  MagnificPopup.init('js-magnific-popup');
})();

/* ---------------------------------------------------------------------- */
/*  Date picker
/* ---------------------------------------------------------------------- */

//init datepickers
$( function() {
  $('.datepicker').each(function () {
    const datepick = new Datepicker(this);
    datepick.createDatePicker();
  });
});

/* ---------------------------------------------------------------------- */
/*  DLCenter functionality
/* ---------------------------------------------------------------------- */
(function () {
  DownloadCenter.init();
})();

/* ---------------------------------------------------------------------- */
/*  Product search
/* ---------------------------------------------------------------------- */
(function () {
  var productSearch = new ProductSearch('js-product-search', 'product-search');
  productSearch.init();
})();

/* ---------------------------------------------------------------------- */
/*  Questionnaire
/* ---------------------------------------------------------------------- */
(function () {
  var questionnaire = new Questionnaire('js-questionnaire', 'questionnaire');
  questionnaire.init();
})();

/* ---------------------------------------------------------------------- */
/*  Extranet
/* ---------------------------------------------------------------------- */
(function () {
  // No use for extranet functionality on normal pages, for now
  //var extranet = new Extranet();
})();

/* ---------------------------------------------------------------------- */
/*  Extranet navigation
/* ---------------------------------------------------------------------- */
(function () {
  var nav = new ExtranetNavigation('extranet-nav');
  nav.init();
})();

/* ---------------------------------------------------------------------- */
/*  Side panels
/* ---------------------------------------------------------------------- */
(function () {
  var sidePanel = new SidePanel('side-panel');
  sidePanel.init();
})();

/* ---------------------------------------------------------------------- */
/*  Responsive tables
/* ---------------------------------------------------------------------- */
(function () {
  var eTable = new ExtranetTable('table-extranet--big');
  eTable.init();
})();

/* ---------------------------------------------------------------------- */
/*  MailChimp forms
/* ---------------------------------------------------------------------- */
(function () {
  $('.js-mailchimp-form').each(function () {
    var form = new MailChimpForm(this, 'mailchimp-form');
    form.init();
  });
})();

/* ---------------------------------------------------------------------- */
/*  Top bar / Language menu
/* ---------------------------------------------------------------------- */
(function () {
  // Change language on select change
  $('.js-top-bar__hidden-select').on('change', function () {
    location.pathname = $(this).val();
  });
})();

/* ---------------------------------------------------------------------- */
/*  Material bank
/* ---------------------------------------------------------------------- */
$('.js-material-bank').each(function () {
  var materialBank = new MaterialBank(this);
  materialBank.init();
});

/* ---------------------------------------------------------------------- */
/*  Material bank app
/* ---------------------------------------------------------------------- */
(function () {
  var materialBankApp = new MaterialBankApp('.v3-app-material-bank');
  materialBankApp.init();
})();

/* ---------------------------------------------------------------------- */
/*  Download center (v3)
/* ---------------------------------------------------------------------- */
(function () {
  var downloadCenterv3 = new DownloadCenterv3('.v3-app-download-center');
  downloadCenterv3.init();
})();

/* ---------------------------------------------------------------------- */
/*  Search Element
/* ---------------------------------------------------------------------- */
$('#search-icon').click(function() {
  $('#js-mobile-search').toggle();
});

/* ---------------------------------------------------------------------- */
/*  Extranet - Excavator Specification - Adapter Info
/* ---------------------------------------------------------------------- */
$('.selection-grid').each(function () {
  var selectionGrid = new SelectionGrid(this);
  selectionGrid.init();
});

/* ---------------------------------------------------------------------- */
/*  Manual filter
/* ---------------------------------------------------------------------- */
(function () {

  var manuals = $('.material-bank__item');

  // Filter operation manual visibility based on search form
  $('#manual-model-search').on('keyup', function (element) {
    let value = (<HTMLInputElement>document.getElementById('manual-model-search')).value;
    manuals.each(function () {
      var model = $(this).data('model').toLowerCase();

      if (model.search(value) > -1) {
        $(this).show();
      }
      else {
        $(this).hide();
      }
    });
  });


  $('#manual-serialnumber-search').on('keyup', function (element) {
    var value = (<HTMLInputElement>document.getElementById('manual-serialnumber-search')).value;
    var model = (<HTMLInputElement>document.getElementById('manual-model-search')).value;
    manuals.each(function () {
      var serial = $(this).data('serial').toLowerCase();
      var model = $(this).data('model').toLowerCase();

      if (serial.search(value) > -1 && model.search(value) > -1) {
        $(this).show();
      }
      else {
        $(this).hide();
      }
    });
  });

})();

/* ---------------------------------------------------------------------- */
/*  Customer machine files
/* ---------------------------------------------------------------------- */

(function () {
  $('.js-machine-files').each(function () {
    var machineFiles = new MachineFiles(this);
    machineFiles.init();
  });
})();



/* ---------------------------------------------------------------------- */
/*  Spare part search
/* ---------------------------------------------------------------------- */
(function () {
  if($('#js-sparepart-search').length) {
    const sparePartSearch = new SparePartSearch('js-sparepart-search', '/stage-ajax/search-spare-parts/', '#mustache-sparepart-search-results', '.js-sparepart-search-results');
    sparePartSearch.attachSubmitListener();
  }
})();


/* ---------------------------------------------------------------------- */
/*  Fetch and search file lists
/* ---------------------------------------------------------------------- */
(function () {
  if($('#js-material-bank--fetch').length) {
    document.addEventListener('DOMContentLoaded', fetchFolderData(), false);
  }
})();


/* ---------------------------------------------------------------------- */
/*  Spare part search
/* ---------------------------------------------------------------------- */
(function () {
  if($('#js-sparepart-book-search').length) {
    const sparePartBookSearch = new SparePartBookSearch('js-sparepart-book-search', '/stage-ajax/sparepart-book-search/', '.js-sparepart-books-template', '.js-sparepart-book-search__results');
    sparePartBookSearch.attachSubmitListener();
  }
})();


/* ---------------------------------------------------------------------- */
/*  Spare part cart
/* ---------------------------------------------------------------------- */
(function () {
  if($('.js-sparepart-cart-form').length) {
    const sparePartCart = new SparePartCart();
    sparePartCart.attachListeners();
  }
})();

/* ---------------------------------------------------------------------- */
/*  Form coditional content
/* ---------------------------------------------------------------------- */
(function () {
  const forms = Array.from(document.querySelectorAll('.js-form-conditional'));
  forms.forEach((form:Element) => {
    const conditionalForm = new FormWithConditionals(form);
    conditionalForm.init();
  });
})();

/* ---------------------------------------------------------------------- */
/*  Spare part cart
/* ---------------------------------------------------------------------- */
(function () {
  if($('#sparepart-cart-contact-form').length) {
    const sparePartCart = new SparePartCartContact();
    sparePartCart.attachListeners();
  }
})();

/* ---------------------------------------------------------------------- */
/*  Spare part cart
/* ---------------------------------------------------------------------- */
(function () {
  if($('#sparepart-cart-contact-form').length) {
    const sparePartOrderProcess = new SparePartOrderProcess();
    sparePartOrderProcess.attachListeners();
  }
})();

/* ---------------------------------------------------------------------- */
/*  Commissioning report
/* ---------------------------------------------------------------------- */
(function () {
  if($('#commissioning-report-form').length) {
    const commissioningReport = new CommissioningReport();
    commissioningReport.init();
    commissioningReport.attachListeners();
  }
})();


/* ---------------------------------------------------------------------- */
/*  Warranty Claim Search
/* ---------------------------------------------------------------------- */
(function () {
  //dynamic import
  if(document.querySelector('#warranty-claim-search')) {
    import('./components/WarrantyClaimSearch').then(module => {
      const WarrantyClaimSearch = module.WarrantyClaimSearch;
      const wcSearch = new WarrantyClaimSearch('warranty-claim-search', '/stage-ajax/get-serialnumber/', '.js-template', '.js-results');
      wcSearch.attachSubmitListener();
    });
  }
})();

/* ---------------------------------------------------------------------- */
/*  Warranty Claim Form
/* ---------------------------------------------------------------------- */
(function () {
  //dynamic import
  const warrantyFormContainer = document.querySelector('.warranty-claim-form')
  if(warrantyFormContainer) {
    import('./components/WarrantyClaimForm').then(module => {
      const WarrantyClaimForm = new module.WarrantyClaimForm(warrantyFormContainer);
      WarrantyClaimForm.init();
    });
  }
})();

/* ---------------------------------------------------------------------- */
/*  Files Upload Form
/* ---------------------------------------------------------------------- */
(function () {
  //dynamic import
  const fileUploadFormContainer = document.querySelector('.upload-files-form')
  if(fileUploadFormContainer) {
    import('./components/FilesUploadForm').then(module => {
      const FilesUploadForm = new module.FilesUploadForm(fileUploadFormContainer);
      FilesUploadForm.init();
    });
  }
})();

/* ---------------------------------------------------------------------- */
/*  Master js
/* ---------------------------------------------------------------------- */
(function () {
  master();
})();

/* ---------------------------------------------------------------------- */
/*  My Movax
/* ---------------------------------------------------------------------- */
const myMovaxCard = document.querySelector('.js-mymovax-card')
if (myMovaxCard) {
  import('./components/MyMovaxCard').then(module => {
    const search = module.default
    search.Init()
  })
}

/**
 *  If add to calendar button is found on page, import the calendar component and initialize it.
 *
 */

const addToCalendarButton = document.querySelector('#addToCalendar')
if (addToCalendarButton) {
  import('./components/addToCalendar').then(module => {
    const addToCalendar = module.default
    addToCalendar.init()
  })
}
